// === SAA:UI:BADGE ===
// Product-card badge pill: icon + uppercase micro-text. One component, variants
// via prop (Vaak gekozen = filled brand red, Binnenkort = soft primary tint).
// SAA overrides core's "Aanbevolen" for products.mostChosen in src/i18n/nl.json.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Clock, Sparkle } from 'phosphor-react';
import { commonStyles } from '../styles/commonStyles';

export type BadgeVariant = 'recommended' | 'comingSoon';

export const Badge: React.FC<{ variant: BadgeVariant }> = ({ variant }) => {
  const { t } = useTranslation();
  const recommended = variant === 'recommended';
  const Icon = recommended ? Sparkle : Clock;

  return (
    <span style={{ ...commonStyles.badgePill, ...(recommended ? commonStyles.badgeRecommended : commonStyles.badgeComingSoon) }}>
      <Icon size={12} weight={recommended ? 'fill' : 'bold'} aria-hidden="true" />
      {t(recommended ? 'products.mostChosen' : 'products.comingSoon')}
    </span>
  );
};

export default Badge;
